var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarouselArrowGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3807_25328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9542 12.6126V12.6042C21.9833 12.5334 22 12.4584 22 12.3751C22 12.2917 21.9833 12.2167 21.9542 12.1459V12.1376C21.9208 12.0584 21.875 11.9917 21.8167 11.9334L13.0667 3.1834C12.8208 2.93757 12.425 2.93757 12.1833 3.1834C11.9375 3.42923 11.9375 3.82507 12.1833 4.06673L19.8667 11.7501H2.625C2.27917 11.7501 2 12.0292 2 12.3751C2 12.7209 2.27917 13.0001 2.625 13.0001H19.8667L12.1833 20.6834C11.9375 20.9292 11.9375 21.3251 12.1833 21.5667C12.3042 21.6876 12.4667 21.7501 12.625 21.7501C12.7833 21.7501 12.9458 21.6876 13.0667 21.5667L21.8167 12.8167C21.875 12.7584 21.9208 12.6876 21.9542 12.6126Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3807_25328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18.75,
    fill: "white",
    transform: "translate(2 3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselArrowGreen);
export default __webpack_public_path__ + "static/media/carousel-arrow-green.99e939297fb6fff93c2c73c97a24ac68.svg";
export { ForwardRef as ReactComponent };